/**
=========================================================
* Soft UI Dashboard PRO React - v4.0.0
=========================================================

* Product Page: https://www.creative-tim.com/product/soft-ui-dashboard-pro-react
* Copyright 2022 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

import { Button, Typography } from '@mui/material'
import YouTubeIcon from '@mui/icons-material/YouTube'
import LinkCell from 'layouts/applications/data-tables/components/LinkCell'

const investmentReferencesData = {
  columns: [
    {
      Header: 'resource Link',
      accessor: 'resourceLink',
      Cell: ({ value: [name, data] }) => (
        <Button
          sx={[
            {
              textTransform: 'none',
              fontSize: '15px',
              color: '#344767',
              fontWeight: 'bold',
              boxShadow: 'none',
              padding: '0px',
            },
            {
              '&:hover, &:focus, &:active, &:focus:not(:hover)': {
                transform: 'none',
                color: '#293852',
                boxShadow: 'none',
              },
              '>span': {
                marginBottom: '2px',
              },
              '&.MuiButton-root .MuiButton-startIcon svg': {
                fontSize: '2rem !important',
              },
            },
          ]}
          startIcon={<YouTubeIcon />}
          onClick={() => window.open(`${data.link}`, '_blank')}
        >
          {name}
        </Button>
      ),
    },
    {
      Header: 'posting date',
      accessor: 'postingDate',
      Cell: ({ value }) => <Typography variant="body2">{value}</Typography>,
    },
  ],

  rows: [
    {
      resourceLink: [
        'Updated! Deferred Resignation - What You Need To Know',
        { link: 'https://youtu.be/AhXaHsngs2M' },
      ],
      postingDate: '2/5/2025',
    },
    {
      resourceLink: [
        'Deferred Resignation - What You Need To Know',
        { link: 'https://youtu.be/UBvIJI02FLY' },
      ],
      postingDate: '1/31/2025',
    },
    {
      resourceLink: [
        "Market Volatility's Impact on Feds",
        { link: 'https://www.youtube.com/watch?v=gAfJDPdV98Y' },
      ],
      postingDate: '2/8/2022',
    },
    {
      resourceLink: [
        'Why Feds are Different',
        { link: 'https://www.youtube.com/watch?v=MZ73R3yvzeI' },
      ],
      postingDate: '2/8/2022',
    },
    {
      resourceLink: [
        'Secret Federal Retirement Strategies Pt II',
        { link: 'https://www.youtube.com/watch?v=1iXuKP7cxn0' },
      ],
      postingDate: '12/21/2021',
    },
    {
      resourceLink: [
        "Secret Retirement Strategies HR Can't Share Pt I",
        { link: 'https://www.youtube.com/watch?v=RL5-LmNEWZs' },
      ],
      postingDate: '12/9/2021',
    },
    {
      resourceLink: [
        'End of 2021 Federal Checklist',
        { link: 'https://www.youtube.com/watch?v=5jyxnv4K-L4' },
      ],
      postingDate: '11/19/2021',
    },
    {
      resourceLink: [
        'PSLF Limited Waiver',
        { link: 'https://www.youtube.com/watch?v=itv4mux8x5g' },
      ],
      postingDate: '11/19/2021',
    },
    {
      resourceLink: [
        'Social Security: Questioning Conventional Wisdom',
        { link: 'https://www.youtube.com/watch?v=bndc0RKeK-M' },
      ],
      postingDate: '10/24/2021',
    },
    {
      resourceLink: [
        'Survivor Benefit: Overpriced or Undervalued?',
        { link: 'https://www.youtube.com/watch?v=nYebPYOGa80' },
      ],
      postingDate: '10/24/2021',
    },
    {
      resourceLink: [
        'Student Loan Forgiveness for Feds',
        { link: 'https://www.youtube.com/watch?v=7MX4cCvrk9I' },
      ],
      postingDate: '10/24/2021',
    },
    {
      resourceLink: [
        'FEGLI: How Much is Too Much?',
        { link: 'https://www.youtube.com/watch?v=Ik1wRxp9YzU' },
      ],
      postingDate: '8/26/2021',
    },
    {
      resourceLink: [
        'Retiring before 60: Can it Be Done?',
        { link: 'https://www.youtube.com/watch?v=6fKCQn8F9U0' },
      ],
      postingDate: '8/26/2021',
    },
    {
      resourceLink: [
        "The G Fund's Frozen Interest",
        { link: 'https://www.youtube.com/watch?v=KVcQRvVWa4c' },
      ],
      postingDate: '8/26/2021',
    },
    {
      resourceLink: [
        'Long Term Care for Feds',
        { link: 'https://www.youtube.com/watch?v=UFmKQrsW7us' },
      ],
      postingDate: '8/12/2021',
    },
    {
      resourceLink: [
        'Roth Conversions',
        { link: 'https://www.youtube.com/watch?v=D7TZ5GdBQKo' },
      ],
      postingDate: '8/12/2021',
    },
    {
      resourceLink: [
        'Inflation: The Silent Tax on Federal Retirement',
        { link: 'https://www.youtube.com/watch?v=52mJCfzUN8s' },
      ],
      postingDate: '8/12/2021',
    },
    {
      resourceLink: [
        'From Veteran to Federal Civilian',
        { link: 'https://www.youtube.com/watch?v=vwOCB79Jc2A' },
      ],
      postingDate: '8/12/2021',
    },
    {
      resourceLink: [
        'Required Minimum Distributions (RMDs)',
        { link: 'https://www.youtube.com/watch?v=eG8CXR4RjR8' },
      ],
      postingDate: '8/11/2021',
    },
    {
      resourceLink: [
        'The G Fund: The Largest Fund in the TSP',
        { link: 'https://www.youtube.com/watch?v=yjrFffUiYmM' },
      ],
      postingDate: '8/11/2021',
    },
    {
      resourceLink: [
        'TSP Distribution: Weighing Your Options',
        { link: 'https://www.youtube.com/watch?v=GvoJtZwIyTA' },
      ],
      postingDate: '8/11/2021',
    },
    {
      resourceLink: [
        'Post-Pandemic Retirement Planning',
        { link: 'https://www.youtube.com/watch?v=eLgEeQmguFg' },
      ],
      postingDate: '8/11/2021',
    },
    {
      resourceLink: [
        'Medicare & FEHB',
        { link: 'https://www.youtube.com/watch?v=-HyzBJbOXQA' },
      ],
      postingDate: '8/11/2021',
    },
    {
      resourceLink: [
        'Postal Particulars',
        { link: 'https://www.youtube.com/watch?v=6s0LaLdf3yo' },
      ],
      postingDate: '8/11/2021',
    },
    {
      resourceLink: [
        'Sick Leave: A Unique Benefit',
        { link: 'https://www.youtube.com/watch?v=0NUPa1KB0TE' },
      ],
      postingDate: '8/11/2021',
    },
    {
      resourceLink: [
        'Military Buyback Guide',
        { link: 'https://www.youtube.com/watch?v=GFVwtfiJtNI' },
      ],
      postingDate: '8/11/2021',
    },
    {
      resourceLink: [
        'Preparing for Federal Retirement in 2021',
        { link: 'https://www.youtube.com/watch?v=bSv6BhNc_bk' },
      ],
      postingDate: '8/11/2021',
    },
    {
      resourceLink: [
        'TSP Tactics during Covid-19',
        { link: 'https://www.youtube.com/watch?v=EWoqZN0x80Q' },
      ],
      postingDate: '8/4/2021',
    },
  ],
}

export default investmentReferencesData
